var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMy(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 40,
    fill: "none",
    viewBox: "0 0 54 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    width: 54,
    height: 40,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.7 0H54v40H.7z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#c00",
    d: "M.7 0H54v40H.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c00",
    d: "M.7 0H54v2.9H.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.7 2.9H54v2.8H.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c00",
    d: "M.7 5.7H54v2.9H.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.7 8.6H54v2.8H.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c00",
    d: "M.7 11.4H54v2.9H.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.7 14.3H54V17H.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c00",
    d: "M.7 17.1H54V20H.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.7 20H54v2.9H.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c00",
    d: "M.7 22.9H54v2.8H.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.7 25.7H54v2.9H.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c00",
    d: "M.7 28.6H54v2.8H.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.7 31.4H54v2.9H.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c00",
    d: "M.7 34.3H54V37H.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.7 37.1H54V40H.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#006",
    d: "M.7 0h26.6v23H.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    d: "m18 6.2.5 3.3 1.9-2.8-1 3.3 2.9-1.8-2.3 2.5 3.4-.2-3.2 1.2 3.2 1.2-3.4-.2 2.3 2.5-3-1.8 1 3.3-1.9-2.8-.4 3.4-.5-3.4-2 2.8 1-3.3-2.9 1.8 2.3-2.5-3.4.2 3.2-1.2-3.2-1.2 3.5.2-2.4-2.5 3 1.8-1-3.3 1.9 2.8zm-2.8 0a6 6 0 1 0 0 11 6.7 6.7 0 1 1 0-11"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.7 0H54v40H.7z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMy);
export default __webpack_public_path__ + "static/media/my.ebb7d6357e9e8a752ce5b0b59cb2a893.svg";
export { ForwardRef as ReactComponent };